import { render, staticRenderFns } from "./EditBasicInfo.vue?vue&type=template&id=98963dfa&"
import script from "./EditBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./EditBasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./EditBasicInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports